import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCZAl1yelA-cFx0FRkGOKanbfxwmHUblL0",
  authDomain: "udrive-ethiopia-1f873.firebaseapp.com",
  databaseURL:
    "https://udrive-ethiopia-1f873-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "udrive-ethiopia-1f873",
  storageBucket: "udrive-ethiopia-1f873.firebasestorage.app",
  messagingSenderId: "900106447108",
  appId: "1:900106447108:web:25c003c66dd12d7d420851",
  measurementId: "G-J0YVLFGT18",
};

const app = initializeApp(firebaseConfig);
const db = getDatabase(app);

export { db };
